import type Item from "./item";

export default class FiltroPadrao{
    estado: string = '';
    municipio: string = '';
    loteStatus: Array<Item> = new Array<Item>();
}